import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom"; // Import de useNavigate
import {
    FaPlay,
    FaPause,
    FaFacebook,
    FaInstagram,
    FaTiktok,
    FaYoutube,
    FaPhone,
    FaUserPlus,
    FaBackward,
    FaForward,
    FaTimes,
    FaArrowLeft,
    FaEnvelope,
} from "react-icons/fa";
import "../styles/Home.css";
import logoFr from "../assets/images/logo.png";
import logoEn from "../assets/images/logo_en_anglais.png";
import couvertureImage from "../assets/images/couverture1.jpg";
import inscriptionlogo from "../assets/images/incription.png";
import inscriptionlogo1 from "../assets/images/porte.png";

// FAQ Component
const FAQ = () => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const questions = t('faq.questions', { returnObjects: true }) || [];

    if (!Array.isArray(questions)) {
        console.error("FAQ questions are not an array:", questions);
        return null; // or render a fallback UI
    }

    return (
        <div className="faq-section">
            <h2 className="faq-title">{t('faq.title')}</h2>
            {questions.map((item, index) => (
                <div key={index} className="faq-item">
                    <div className="faq-question" onClick={() => handleToggle(index)}>
                        <span className="faq-question-text">{item.q}</span>
                        <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
                    </div>
                    {openIndex === index && (
                        <div className="faq-answer">
                            <p>{item.a}</p>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

function Home() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate(); // Utilisation du hook useNavigate
    const [playingTop, setPlayingTop] = useState(false);
    const [playingBottom, setPlayingBottom] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const playerRefTop = useRef(null);
    const playerRefBottom = useRef(null);

    const getYouTubeVideoId = (url) => {
        const regex =
            /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    useEffect(() => {
        setShowModal(true);

        const youTubeScriptUrl = "https://www.youtube.com/iframe_api";

        const getYouTubeVideoId = (url) => {
            const regex =
                /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
            const match = url.match(regex);
            return match ? match[1] : null;
        };

        const initializePlayer = (elementId, playerRef, setPlayingState) => {
            if (playerRef.current) {
                playerRef.current.destroy();
            }

            const videoUrl = t("home.youtube_video_url");
            const videoId = getYouTubeVideoId(videoUrl);

            if (videoId) {
                playerRef.current = new window.YT.Player(elementId, {
                    videoId: videoId,
                    playerVars: {
                        controls: 0,
                        modestbranding: 1,
                        rel: 0,
                        autoplay: 0,
                        showinfo: 0,
                        disablekb: 1,
                    },
                    events: {
                        onReady: (event) => onPlayerReady(event, setPlayingState),
                        onStateChange: (event) => onPlayerStateChange(event, setPlayingState),
                    },
                });
            }
        };

        const onYouTubeIframeAPIReady = () => {
            initializePlayer("youtube-player-top", playerRefTop, setPlayingTop);
            initializePlayer("youtube-player-bottom", playerRefBottom, setPlayingBottom);
        };

        if (!window.YT) {
            const tag = document.createElement("script");
            tag.src = youTubeScriptUrl;
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
        } else {
            onYouTubeIframeAPIReady();
        }

        const elements = document.querySelectorAll(
            ".zone_inscrp, .imagecouverture, .content-area, .description-area, .video-player-area, .main-footer"
        );
        elements.forEach((el, index) => {
            setTimeout(() => {
                el.classList.add("loaded");
            }, 100 * index);
        });

        return () => {
            if (playerRefTop.current) {
                playerRefTop.current.destroy();
                playerRefTop.current = null;
            }
            if (playerRefBottom.current) {
                playerRefBottom.current.destroy();
                playerRefBottom.current = null;
            }
        };
    }, [i18n.language, location.pathname]);

    const onPlayerReady = (event, setPlayingState) => {
        console.log("YouTube Player est prêt !", event);
        setPlayingState(false);
    };

    const onPlayerStateChange = (event, setPlayingState) => {
        if (event.data === window.YT.PlayerState.PLAYING) {
            setPlayingState(true);
        } else {
            setPlayingState(false);
        }
    };

    const handlePlayPause = (playerRef, playingState, setPlayingState) => {
        if (playerRef.current && playerRef.current.playVideo) {
            if (playingState) {
                playerRef.current.pauseVideo();
            } else {
                playerRef.current.playVideo();
            }
        }
    };

    const handleRewind = (playerRef) => {
        if (playerRef.current) {
            const currentTime = playerRef.current.getCurrentTime();
            playerRef.current.seekTo(currentTime - 10, true);
        }
    };

    const handleFastForward = (playerRef) => {
        if (playerRef.current) {
            const currentTime = playerRef.current.getCurrentTime();
            playerRef.current.seekTo(currentTime + 10, true);
        }
    };

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleInscriptionClick = () => {
        // Logique pour gérer l'inscription, par exemple, naviguer vers une autre page
        // Pour l'instant, on se contente de fermer la modale
        closeModal();
    };
     const handleRegisterClick = async () => {
        try {
            // 1. Récupérer les informations sur le lien actuel (URL et ID)
            const response = await fetch('https://back-desalpe.onrender.com/api/inscription/lien-actuel');
            if (!response.ok) {
                console.error("Impossible de récupérer le lien, utilisation de l'URL de secours.");
                window.location.href = '/selection'; // URL de secours
                return;
            }
            const data = await response.json();
            const { destinationUrl, lien_id } = data;

            // 2. Enregistrer l'événement de clic AVEC l'ID du lien
            if (lien_id) {
                fetch('https://back-desalpe.onrender.com/api/click-events', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        click_type: 'CLIC_INVITATION',
                        lien_id: lien_id
                    }),
                    keepalive: true // Empêche le navigateur d'annuler la requête lors de la redirection
                }).catch(error => console.error("Erreur lors de l'enregistrement de l'événement de clic:", error));
            }

            // 3. Rediriger l'utilisateur
            if (destinationUrl) {
                const finalUrl = `${destinationUrl}${destinationUrl.includes('?') ? '&' : '?'}lien_id=${lien_id}`;
                window.location.href = finalUrl;
            } else {
                console.error("Aucune URL de destination, utilisation de l'URL de secours.");
                window.location.href = '/selection';
            }

        } catch (error) {
            console.error("Erreur dans handleRegisterClick :", error);
            window.location.href = '/selection'; // URL de secours en cas d'erreur
        }
    };


    return (
        <div className="home-container">
            {/* Conteneur pour la nouvelle navigation par étapes */}
            <div className="step-navigation">
                <button
                    onClick={() => navigate(-1)} // Navigue vers la page précédente
                    className="inscription-button1"
                >
                    {/* Ajout de la flèche FaArrowLeft avant le texte */}
                    <FaArrowLeft /> {t("home.back_to_previous_step")}
                </button>
            </div>
            <div className="zone_inscrp">
                <div className="text-button-wrapper">
                    <div className="titre">
                        <span>
                            <FaUserPlus className="inscription-icon" />
                        </span>
                        <p>{t("home.community_welcome")}</p>
                    </div>
                </div>

                <img
                    src={inscriptionlogo}
                    alt="Inscription Icon"
                    className="inscription-image"
                />
            </div>
            <div className="video-player-area">
                <div
                    className="player-wrapper"
                    style={{ pointerEvents: "none" }}
                >
                    <div id="youtube-player-top"></div>
                </div>
                <p className="video-instruction">{t("home.click_to_play")}</p>
                <div className="video-controls">
                    <button
                        onClick={() => handleRewind(playerRefTop)}
                        className="video-control-button"
                    >
                        <FaBackward />
                    </button>
                    <button
                        onClick={() =>
                            handlePlayPause(
                                playerRefTop,
                                playingTop,
                                setPlayingTop
                            )
                        }
                        className="play-pause-button"
                    >
                        {playingTop ? <FaPause /> : <FaPlay />}
                    </button>
                    <button
                        onClick={() => handleFastForward(playerRefTop)}
                        className="video-control-button"
                    >
                        <FaForward />
                    </button>
                </div>
            </div>
            <div className="zonne_button">
                <button
                    onClick={handleRegisterClick}
                    className="inscription-button"
                >
                    {t("home.register_button")}
                </button>
            </div>
            <div>
                <img
                    src={couvertureImage}
                    alt="Couverture"
                    className="imagecouverture"
                />
            </div>
            <div className="content-area">
                <h2 className="main-title">{t("home.main_title")}</h2>
                <p className="subtitle">{t("home.subtitle")}</p>
                <p className="team-description">{t("home.team_description")}</p>
                <div className="social-links">
                    <a
                        href="https://www.youtube.com/@GraceDesAlpes"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaYoutube className="social-icon" />
                    </a>
                    <a
                        href="https://www.facebook.com/profile.php?id=61578512616381"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaFacebook className="social-icon" />
                    </a>
                    <a
                        href="https://www.instagram.com/gracedesalpes/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaInstagram className="social-icon" />
                    </a>
                    <a
                        href="YOUR_TIKTOK_LINK"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaTiktok className="social-icon" />
                    </a>
                </div>
            </div>
            <div className="membership-section">
                {/* TITRE PRINCIPAL */}
                <h2 className="section-title">
                    {t("home.title_member_status")}
                </h2>

                {/* INTRODUCTION */}
                <p className="intro-text">
                    {t("home.description_member_intro")}
                </p>

                {/* LISTE DES STATUTS (Utilisation de <ul>/<li> pour la clarté) */}
                <ul className="status-list">
                    <li className="status-item client">
                        <span className="status-name">
                            {t("home.status_client").split(" :")[0]} :
                        </span>
                        {t("home.status_client").split(" :")[1]}
                    </li>
                    <li className="status-item active-member">
                        <span className="status-name">
                            {t("home.status_active_member").split(" :")[0]} :
                        </span>
                        {t("home.status_active_member").split(" :")[1]}
                    </li>
                    <li className="status-item entrepreneur">
                        <span className="status-name">
                            {t("home.status_entrepreneur").split(" :")[0]} :
                        </span>
                        {t("home.status_entrepreneur").split(" :")[1]}
                    </li>
                    <li className="status-item ambassador">
                        <span className="status-name">
                            {t("home.status_ambassador").split(" :")[0]} :
                        </span>
                        {t("home.status_ambassador").split(" :")[1]}
                    </li>
                </ul>


                {/* APPEL À L'ACTION (CTA) */}
                <p className="cta-text">
                    {t("home.description_invitation_cta")}
                </p>

                {/* CONCLUSION */}
                <p className="conclusion-text">
                    {t("home.description_member_conclusion")}
                </p>
            </div>
            <FAQ />

            <div className="video-player-area">
                <div
                    className="player-wrapper"
                    style={{ pointerEvents: "none" }}
                >
                    <div id="youtube-player-bottom"></div>
                </div>
                <p className="video-instruction">{t("home.click_to_play")}</p>
                <div className="video-controls">
                    <button
                        onClick={() => handleRewind(playerRefBottom)}
                        className="video-control-button"
                    >
                        <FaBackward />
                    </button>
                    <button
                        onClick={() =>
                            handlePlayPause(
                                playerRefBottom,
                                playingBottom,
                                setPlayingBottom
                            )
                        }
                        className="play-pause-button"
                    >
                        {playingBottom ? <FaPause /> : <FaPlay />}
                    </button>
                    <button
                        onClick={() => handleFastForward(playerRefBottom)}
                        className="video-control-button"
                    >
                        <FaForward />
                    </button>
                </div>
            </div>

            <div className="zone_inscrp">
                <div className="text-button-wrapper">
                    <div className="titre">
                        <span>
                            <img
                                src={inscriptionlogo1}
                                alt="Inscription Icon"
                                className="inscription-image"
                            />
                        </span>
                        <p>{t("home.community_welcome")}</p>
                    </div>
                </div>
                <div className="zonne_button">
                    <button
                        onClick={handleRegisterClick}
                        className="inscription-button"
                    >
                        {t("home.register_button")}
                    </button>
                </div>
            </div>

            <footer className="main-footer">
                <div className="footer-section logo-section">
                    <img
                        src={i18n.language === "en" ? logoEn : logoFr}
                        alt="Footer Logo"
                        className="footer-logo"
                    />
                    <h3 className="grace-team-title">GRACE DES ALPES</h3>
                </div>

                <div className="footer-section contact-section">
                    <h4>{t("home.contact_us")}</h4>
                    <p>
                        <FaEnvelope className="contact-icon" /> email :
                        Info@gracedesalpes.ca
                    </p>
                </div>

                <div className="footer-section social-footer-section">
                    <h4>{t("home.follow_us")}</h4>
                    <div className="social-links-footer">
                        <a
                            href="https://www.youtube.com/@GraceDesAlpes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaYoutube className="social-icon-footer" />
                        </a>
                        <a
                            href="https://www.facebook.com/CommunauteGracedesAlpes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaFacebook className="social-icon-footer" />
                        </a>
                        <a
                            href="https://www.instagram.com/gracedesalpes/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaInstagram className="social-icon-footer" />
                        </a>
                        <a
                            href="YOUR_TIKTOK_LINK"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaTiktok className="social-icon-footer" />
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Home;
